import React, { memo } from 'react';
import './Companies.css';
import logo1 from '../../images/logo1.svg'
import logo2 from '../../images/logo2.svg'
import logo3 from '../../images/logo3.svg'
import logo4 from '../../images/logo4.svg'
import logo5 from '../../images/logo5.svg'
import logo7 from '../../images/logo7.png'
import logo8 from '../../images/logo8.svg'
import logo9 from '../../images/logo9.svg'
import logo10 from '../../images/logo10.svg'
import logo12 from '../../images/logo12.svg'
import logo13 from '../../images/logo13.svg'
import logo14 from '../../images/logo14.svg'
import logo15 from '../../images/logo15.svg'
import logo16 from '../../images/logo16.svg'
import logo17 from '../../images/logo17.svg'
import logo18 from '../../images/logo18.svg'
import logo19 from '../../images/logo19.png'
import logo20 from '../../images/logo20.png'
import logo21 from '../../images/logo21.png'
import logo22 from '../../images/logo22.png'
import logo23 from '../../images/logo23.png'







const Companies = memo(() => {
    return (
        <div id='companies' className='companies'>
                <h1>
                  Rebase students are hired by companies of all sizes, globally
                </h1>
                <div className='contents'>            
                    <img alt="" src={logo1} />                 
                    <img alt="" src={logo2} />                   
                    <img alt="" src={logo3} />                  
                    <img alt="" src={logo4} />                   
                    <img alt="" src={logo5} />
                    <img alt="" src={logo7} />
                    <img alt="" src={logo8} />
                    <img alt="" src={logo9} />
                    <img alt="" src={logo10} />
                    <img alt="" src={logo12} />
                    <img alt="" src={logo13} />
                    <img alt="" src={logo14} />
                    <img alt="" src={logo15} />
                    <img alt="" src={logo16} />
                    <img alt="" src={logo17} />
                    <img alt="" src={logo18} />
                    <img alt="" src={logo19} />
                    <img alt="" src={logo20} />
                    <img alt="" src={logo21} />
                    <img alt="" src={logo22} />
                    <img alt="" src={logo23} />
                </div>
        </div>
    );
});

export default Companies;